import { Component, OnInit, OnDestroy, ViewChild, ViewEncapsulation, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { MatSidenav } from '@angular/material/sidenav';
import { LoginService } from 'app/services/login.service';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css'],
  encapsulation: ViewEncapsulation.Emulated 
})
export class HomePageComponent implements OnInit, OnDestroy {
  showTooltip: boolean = false;
  showTooltipSeguimiento: boolean = false;
  tooltipStyles = {
    top: '60px',
    left: '0',
  };

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches),
    shareReplay()
  );
  @ViewChild(MatSidenav) sidenav: MatSidenav;
  dateActual: number;
  mostrarSubmenuDSA: boolean = false;
  public maestrias:any[] = [
    {
      nombre:"Maestría en Gestión Informática",
      subtitulo: "Formar profesionales en el área informática con las competencias técnico-científicas requeridas por el mercado local y externo, Capacidad para crear, planear, diseñar y gestionar proyectos de tecnologías de información y comunicaciones, que contribuyan al logro de los objetivos estratégicos de las organizaciones pública y privada.",

    },
    {
      nombre:"Maestría en Psicología Clínica",
      subtitulo: "Formar especialistas que promuevan la salud mental, a través de la investigación, prevención, evaluación e intervención psicológica, a fin de contribuir a disminuir los problemas de salud mental en el área o campo clínico.",
    
    },
    {
      nombre:"Maestría en Administración de Empresas",
      subtitulo: "Formar especialistas con competencias a nivel local como internacional requeridas para desempeñarse en el ámbito empresarial, con pensamiento crítico y creativo en el análisis de la problemática de las organizaciones, desde una perspectiva ética y sustentable.",
   
    },
    {
      nombre:"Maestría en Sociología",
      subtitulo: "Formar profesionales e investigadores con sensibilidad y compromiso ético, capaces de aportar nuevos conocimientos al campo de la sociología en Honduras dotados de una sólida base teórica y metodológica para garantizar el rigor y la calidad de sus investigaciones, para que puedan desempeñarse eficazmente en los distintos ámbitos de la profesión.",

    },
    {
      nombre:"	Maestría en Epidemiología",
      subtitulo: "Participar, usando herramientas epidemiológicas, en el proceso de atención y gerencia de los servicios de salud, asegurando la prestación de servicios de calidad, planificación, ejecución y evaluación de intervenciones, programas dirigidos a la prevención y control de problemas de salud enfermedad relevantes.",
  
    },
    {
      nombre:"Maestría en Historia Social y Cultural",
      subtitulo: "Contribuir al desarrollo social y cultural de Honduras a través de la información de profesionales que aporten sus conocimientos y su concurso al fortalecimiento de una identidad nacional diversa y plural.",

    }
    ,
    {
      nombre:"Maestría en Astronomía y Astrofísica",
      subtitulo: "Desarrolla habilidades en ciencia de datos, tecnología espacial y comunicación científica, en un entorno académico altamente especializado y con visión global. Ideal para quienes buscan impactar en universidades, centros de investigación o industrias tecnológicas con innovación, ética y compromiso social.",

    }
    ,
    {
      nombre:"Doctorado en Derecho",
      subtitulo: "Formar profesionales a nivel de doctorado en el campo del Derecho, calificados para desarrollar investigación jurídica de calidad, tanto de investigación básica como aplicada, que produzca conocimiento científico en respuesta a los principales problemas del Sistema Jurídico Nacional y de la sociedad hondureña.",

    }
  ];

  constructor(public router:Router, private breakpointObserver: BreakpointObserver, private loginAd: LoginService, private _renderer: Renderer2) {
    this.dateActual = new Date().getFullYear();
  }

  ngOnInit(): void {
    localStorage.clear();
    document.documentElement.style.backgroundColor = '#052b63';
  }

  ngOnDestroy(): void {
    document.documentElement.style.backgroundColor = '';
  }

  solicitudIngreso(item){
    this.router.navigateByUrl(`fichaAdmision/${item.idCentro}/${item.idPosgrado}`);
  }

  ofertaAcademica(){
    this.router.navigateByUrl(`ofertaAcademica`);
  }

  verMas(){

    // window.location.href = 'https://posgrados.unah.edu.hn/oferta-de-posgrados/';
    window.open('https://posgrados.unah.edu.hn/oferta-de-posgrados/');
  
}
  loginEstudiante(){
    this.router.navigateByUrl(`estudiante/login`);
  }

  // loginAdministrativo(){
  //   this.router.navigateByUrl(`login`);
  // }
  loginAdministrativo1(){
    // this.loginAd.setData('login', 'loginP1');
    sessionStorage.setItem('login', 'loginP1');
    this.router.navigate(['login']);
  }
  loginAdministrativo2(){
    // this.loginAd.setData('login', 'loginC2');
    sessionStorage.setItem('login', 'loginC2');
    this.router.navigate(['login']);
  }
  loginAdministrativo3(){
    // this.loginAd.setData('login', 'loginG3');
    sessionStorage.setItem('login', 'loginG3');
    this.router.navigate(['login']);
  }
  loginAdministrativo4(){
    // this.loginAd.setData('login', 'loginDS');
    sessionStorage.setItem('login', 'loginDS');
    this.router.navigate(['login']);
  }
  loginAdministrativo5(){
    // this.loginAd.setData('login', 'loginDI');
    sessionStorage.setItem('login', 'loginDI');
    this.router.navigate(['login']);
  }

  loginDSA1(){
    sessionStorage.setItem('login', 'loginDSA1');
    this.router.navigate(['login']);
  }
  loginComisionDSA(){
    this.router.navigateByUrl('dsa/login');
  }

  loginPostulante(){
    this.router.navigateByUrl('postulante/login');
  }
}
